import { GraphQLObjectType } from 'graphql'
import { archiveApplication } from './mutations/archive-application'
import { restoreApplication } from './mutations/restore-application'
import { applyApplicationLicense } from './mutations/apply-application-license'
import { deleteApplication } from './mutations/delete-application'
import {
  deleteServer,
  deleteServers,
  deleteServersByFilters
} from './mutations/delete-server'
import { deleteRoute } from './mutations/delete-route'
import { setServerAssess } from './mutations/set-server-assess'
import { setServerProtect } from './mutations/set-server-protect'
import {
  archiveApplications,
  archiveApplicationsByFilters
} from './mutations/archive-applications'
import {
  restoreApplications,
  restoreApplicationsByFilters
} from './mutations/restore-applications'
import {
  deleteApplications,
  deleteApplicationsByFilters
} from './mutations/delete-applications'
import {
  modifyApplicationTags,
  modifyApplicationTagsByFilters,
  modifyServersTags,
  modifyServerTagsByFilters,
  modifyVulnerabilitiesTags,
  modifyVulnerabilitiesTagsByFilters,
  modifyLibraryTags,
  modifyLibrariesTagsByFilters
} from './mutations/modify-tags'
import {
  mergeApplications,
  mergeApplicationsByFilters
} from './mutations/merge-applications'
import { markAsViewedSlidingTutorial } from './mutations/mark-viewed-sliding-tutorial'
import { changeServerEnvironment } from './mutations/change-server-environment'
import {
  updateServerSettings,
  updateServerSettingsByIds,
  updateServerSettingsByFilters
} from './mutations/update-server-settings'
import { updateDiagnosticCollectionSettings } from './mutations/update-diagnostic-collection'
import { mergeVulnerabilities } from './mutations/merge-vulnerabilities'
import { updateVulnerabilitySeverity } from './mutations/update-vulnerability-severity'
import {
  sendVulnerabilitiesToEmail,
  sendVulnerabilitiesToEmailByFilters
} from './mutations/send-vulnerabilities-to-email'
import { sendLibrariesToEmailByFilters } from './mutations/send-libraries-to-email-by-filters'
import { sendLibrariesToEmail } from './mutations/send-libraries-to-email'
import {
  updateVulnerabilityStatus,
  updateVulnerabilitiesStatus,
  updateVulnerabilitiesStatusByFilters
} from './mutations/update-vulnerability-status'
import { updateOrganizationApplicationsSettings } from './mutations/update-applications-settings'
import {
  approveVulnerabilitiesStatus,
  denyVulnerabilitiesStatus,
  bulkApproveVulnerabilitiesStatus,
  bulkDenyVulnerabilitiesStatus
} from './mutations/review-vulnerability-status'
import { deleteVulnerabilities } from './mutations/delete-vulnerabilities'
import { updateSensitiveDataPolicy } from './mutations/update-sensitive-data-policy'
import { toggleSensitiveDataPolicy } from './mutations/toggle-sensitive-data-policy'
import { persistStigTemplate } from './mutations/persist-stig-template'
import { updateApprovalWorkflowSettings } from './mutations/approval-workflow-settings'
import { deleteOrgLibrariesByHashes } from './mutations/delete-org-libraries-by-hashes'
import { deleteServerLibrariesByHashes } from './mutations/delete-server-libraries-by-hashes'
import { deleteAppLibrariesByHashes } from './mutations/delete-app-libraries-by-hashes'
import { createVulnerabilityPolicy } from './mutations/create-vulnerability-policy'
import { deleteOrgLibrariesWithFilters } from './mutations/delete-org-libraries-by-filters'

import * as deleteAppLibrariesByFiltersModule from './mutations/delete-app-libraries-by-filters'

import { deleteServerLibrariesWithFilters } from './mutations/delete-server-libraries-by-filters'
import { deleteVulnerabilityPolicy } from './mutations/delete-vulnerability-policy'
import { updateVulnerabilityPolicy } from './mutations/update-vulnerability-policy'
import { enableVulnerabilityPolicy } from './mutations/enable-vulnerability-policy'
import { deleteAttackEventTag } from './mutations/delete-attack-event-tag'
import { updateTelemetryTeamserverPreference } from './mutations/update-telemetry-teamserver-preference'
import { suppressAttackEvent } from './mutations/suppress-attack-event'
import { generateAttestationReport } from './mutations/generate-attestation-report'
import {
  createRuleExclusionCodeType,
  createRuleExclusionInputType,
  createRuleExclusionURLType
} from './mutations/create-rule-exclusion'
import { deleteAttackEventNote } from './mutations/attack-event-note/delete-attack-event-note'
import { updateAttackEventNote } from './mutations/attack-event-note/update-attack-event-note'
import { createAttackEventNote } from './mutations/attack-event-note/create-attack-event-note'
import { updateAttackEventNotesViewed } from './mutations/attack-event-note/update-attack-event-notes-viewed'
import { updateSensitiveDataMaskingSettings } from './mutations/update-sensitive-data-masking-settings'
import { updateEmailDomains } from './mutations/update-email-domains'
import { updateOrganizationDigestSettings } from './mutations/update-organization-digest-settings'
import { updateUserDigestSettings } from './mutations/update-user-digest-settings'
import { toggleOrganizationDiagnostics } from './mutations/toggle-organization-diagnostics'
import { toggleOrganizationRestrictedEditRole } from './mutations/toggle-organization-restricted-edit-role'
import {
  updateApplicationLibraryStatus,
  updateApplicationLibraryStatusByFilters
} from './mutations/update-application-library-status'
import {
  deleteApplicationLibraryStatus,
  deleteApplicationLibraryStatusByFilters
} from './mutations/delete-application-library-status'
import { updateVulnerabilitySubstatusAlias } from './mutations/update-vulnerability-substatus-alias'
import { deleteVulnerabilitySubstatusAlias } from './mutations/delete-vulnerability-substatus-alias'
import { buildRootMutationFields } from './build-root-mutation-fields'

// Note: do not add to this
// Instead: add to buildRootMutationFields() call below
// Follow example used in deleteAppLibrariesByFiltersModule
const fields = {
  archiveApplication,
  restoreApplication,
  applyApplicationLicense,
  deleteApplication,
  archiveApplications,
  archiveApplicationsByFilters,
  restoreApplications,
  restoreApplicationsByFilters,
  deleteApplications,
  deleteApplicationsByFilters,
  modifyApplicationTags,
  modifyApplicationTagsByFilters,
  modifyServersTags,
  modifyServerTagsByFilters,
  modifyVulnerabilitiesTags,
  modifyVulnerabilitiesTagsByFilters,
  modifyLibraryTags,
  modifyLibrariesTagsByFilters,
  mergeApplications,
  mergeApplicationsByFilters,
  markAsViewedSlidingTutorial,
  deleteServer,
  deleteServers,
  deleteServersByFilters,
  deleteRoute,
  setServerAssess,
  setServerProtect,
  changeServerEnvironment,
  updateDiagnosticCollectionSettings,
  updateServerSettings,
  updateServerSettingsByIds,
  updateServerSettingsByFilters,
  mergeVulnerabilities,
  updateVulnerabilitySeverity,
  sendVulnerabilitiesToEmail,
  sendVulnerabilitiesToEmailByFilters,
  updateVulnerabilityStatus,
  updateVulnerabilitiesStatus,
  updateVulnerabilitiesStatusByFilters,
  updateOrganizationApplicationsSettings,
  approveVulnerabilitiesStatus,
  denyVulnerabilitiesStatus,
  bulkApproveVulnerabilitiesStatus,
  bulkDenyVulnerabilitiesStatus,
  deleteVulnerabilities,
  updateSensitiveDataPolicy,
  toggleSensitiveDataPolicy,
  persistStigTemplate,
  updateApprovalWorkflowSettings,
  deleteOrgLibrariesByHashes,
  deleteServerLibrariesByHashes,
  deleteAppLibrariesByHashes,
  createVulnerabilityPolicy,
  deleteOrgLibrariesWithFilters,
  deleteServerLibrariesWithFilters,
  deleteVulnerabilityPolicy,
  updateVulnerabilityPolicy,
  enableVulnerabilityPolicy,
  deleteAttackEventTag,
  updateTelemetryTeamserverPreference,
  suppressAttackEvent,
  generateAttestationReport,
  sendLibrariesToEmail,
  sendLibrariesToEmailByFilters,
  createRuleExclusionCodeType,
  createRuleExclusionInputType,
  createRuleExclusionURLType,
  createAttackEventNote,
  updateAttackEventNote,
  deleteAttackEventNote,
  updateAttackEventNotesViewed,
  updateSensitiveDataMaskingSettings,
  updateEmailDomains,
  updateOrganizationDigestSettings,
  updateUserDigestSettings,
  toggleOrganizationDiagnostics,
  toggleOrganizationRestrictedEditRole,
  updateApplicationLibraryStatus,
  updateApplicationLibraryStatusByFilters,
  deleteApplicationLibraryStatus,
  deleteApplicationLibraryStatusByFilters,
  updateVulnerabilitySubstatusAlias,
  deleteVulnerabilitySubstatusAlias
}

export const mutation = new GraphQLObjectType({
  name: 'Mutation',
  fields: () => {
    return buildRootMutationFields(fields, deleteAppLibrariesByFiltersModule)
  }
})
